import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class SetAiDermPhotoInfoEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  post(req: VisitDetailPhotos.AiDermPostRequest): Observable<VisitDetailPhotos.AiDermResponse> {
    return this.http.post<VisitDetailPhotos.AiDermResponse>(
      `${this.env.constants.serverless_api_url}ai/autoderm/analyse`,
      req,
    );
  }
}
